var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTicket = function SvgTicket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#191F2E",
    d: "M4.5 5.456V6.47h1.125V5.456zM12.375 5.456V6.47H13.5V5.456zM4.5 7.481v1.013h1.125V7.48zM12.375 7.481v1.013H13.5V7.48zM4.5 9.506v1.013h1.125V9.506zM12.375 9.506v1.013H13.5V9.506zM4.5 11.531v1.013h1.125V11.53zM12.375 11.531v1.013H13.5V11.53z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#191F2E",
    d: "M1.688 3.375C.756 3.375 0 4.131 0 5.063V6.75c0 .31.252.563.563.563a1.688 1.688 0 0 1 0 3.375.56.56 0 0 0-.563.562v1.688c0 .931.756 1.687 1.688 1.687h14.625c.931 0 1.687-.755 1.687-1.687V11.25a.56.56 0 0 0-.562-.562 1.687 1.687 0 1 1 0-3.376c.31 0 .562-.251.562-.562V5.063c0-.932-.756-1.688-1.687-1.688zm-.563 1.688c0-.311.252-.563.563-.563h14.625c.31 0 .562.252.562.563v1.18a2.813 2.813 0 0 0 0 5.513v1.181c0 .311-.252.563-.562.563H1.688a.56.56 0 0 1-.563-.562v-1.182a2.813 2.813 0 0 0 0-5.512z"
  })));
};
export default SvgTicket;